import { httpRequest } from "@services/http";
import { Budget, BudgetType, ReplenishFrequency } from "@models/budget.model";
import { BudgetSerializer } from "@models/serializers/budgetSerializer";

export interface UpdateBudgetPayload {
  budget_type?: BudgetType;
  starting_balance?: number;
  replenish_amount?: number | null;
  replenish_frequency?: ReplenishFrequency | null;
  start_date?: string;
  end_date?: string | null;
  is_active?: boolean;
}

export class CommandUpdateBudget {
  async run(budgetId: number, payload: UpdateBudgetPayload): Promise<Budget> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/budgets/${budgetId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return BudgetSerializer.fromJson(response);
  }
}
